import { combineReducers } from 'redux';

import profileForm from './profileForm';
import eventForm from './eventForm';
import loginForm from './loginForm';
import map from './map';
import visual from './visual';
import dateSelector from './dateSelector'
import scheduleForm from './scheduleForm';

const uiReducers = combineReducers({
  profileForm,
  eventForm,
  scheduleForm,
  loginForm,
  map,
  visual,
  dateSelector
});

export default uiReducers;



// WEBPACK FOOTER //
// ./src/reducers/ui/index.js